'use strict';
module.exports = require('./Tooltip.js');